import { useState, useEffect } from 'react';
import { useTheme } from '@mui/material';

export const useDrawerWidthTransitionTimeout = (isExpanded: boolean) => {
  const theme = useTheme();

  const [isFullyExpanded, setIsFullyExpanded] = useState(isExpanded);

  useEffect(() => {
    const delay = isExpanded ? theme.transitions.duration.enteringScreen : 0;

    const timeout = setTimeout(() => {
      setIsFullyExpanded(isExpanded);
    }, delay);

    return () => {
      clearTimeout(timeout);
    };
  }, [isExpanded, theme]);

  return isFullyExpanded;
};
